import { shopSellerRepo } from '../repo/shopSellerRepo';

export const shopSellerService = {
    async getAll(params = {}) {
        try {
            const response = await shopSellerRepo.getAll(params);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getMyShops(params = {}) {
        try {
            return await shopSellerRepo.getMyShops(params);
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getAvailableSellers(params = {}) {
        if (!params.shopId) {
            throw new Error('Shop ID is required');
        }
        try {
            const response = await shopSellerRepo.getAvailableSellers(params);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getById(shopSellerId) {
        if (!shopSellerId) {
            throw new Error('Shop seller ID is required');
        }
        try {
            const response = await shopSellerRepo.getById(shopSellerId);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getByShop(shopId, params = {}) {
        if (!shopId) {
            throw new Error('Shop ID is required');
        }
        try {
            const response = await shopSellerRepo.getByShop(shopId, params);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async setStatus(shopSellerId, status) {
        if (!shopSellerId) {
            throw new Error('Shop seller ID is required');
        }
        if (!['active', 'inactive'].includes(status)) {
            throw new Error('Status must be "active" or "inactive"');
        }

        try {
            const response = await shopSellerRepo.setStatus(shopSellerId, status);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },


    async getTotalByShop(shopId) {
        if (!shopId) {
            throw new Error('Shop ID is required');
        }
        try {
            const response = await shopSellerRepo.getTotalByShop(shopId);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async create(data) {
        if (!data.shopId) {
            throw new Error('Shop ID is required');
        }
        if (!data.username) {
            throw new Error('Username is required');
        }

        try {
            const response = await shopSellerRepo.create(data);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async update(shopSellerId, data) {
        if (!shopSellerId) {
            throw new Error('Shop seller ID is required');
        }

        try {
            const response = await shopSellerRepo.update(shopSellerId, data);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async toggleStatus(shopSellerId) {
        if (!shopSellerId) {
            throw new Error('Shop seller ID is required');
        }

        try {
            const response = await shopSellerRepo.toggleStatus(shopSellerId);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getStats(shopId) {
        try {
            const response = await this.getTotalByShop(shopId);
            return response.data?.data || {
                total_sellers: 0,
                active_sellers: 0,
                inactive_sellers: 0
            };
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getSellersByShopWithDetails(shopId, params = {}) {
        try {
            const response = await this.getByShop(shopId, params);
            const sellers = response.data?.data || [];
            return {
                sellers,
                total: sellers.length,
                active: sellers.filter(s => s.status === 'active').length,
                inactive: sellers.filter(s => s.status === 'inactive').length,
            };
        } catch (error) {
            throw this.handleError(error);
        }
    },

    handleError(error) {
        console.error('ShopSellerService Error:', error);
        return error.response?.data || error;
    },
};